import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  rootHeaderTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    backgroundColor: '#F5F5F5',
    margin: '0 0 5px 0',
    width: '99%',
    border: '1px solid #D9D5D5',
    boxShadow: 'none',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  container: {
    display: 'flex',
    marginLeft: '2rem',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    margin: '1rem',
    fontWeight: 'bold',
  },
}));

export default useStyles;
